import { Form, Input, Col, Row, Spin, Select } from "antd";
import { useTranslate } from "@refinedev/core";
import React, { FC } from "react";

interface FormVerticalProps {
  formXlsProps: any;
  handleSave?: any;
}

/**
 * Sólo los campos (xcons-docs#609): el título con el botón de subir el Excel van arriba, fuera
 * del recuadro, y Cancelar / Guardar en el pie fijo del panel.
 */
export const FormVerticalImportsProducts: FC<FormVerticalProps> = React.memo(
  ({ formXlsProps, handleSave }) => {
    const t = useTranslate();

    return (
      <Form
        {...formXlsProps}
        onFinish={handleSave}
        style={{ width: "100%" }}
        layout="vertical"
      >
        <Spin spinning={false}>
          <Row gutter={40} wrap justify="start">
            {/* De a pares, un Col por campo: así cada fila arranca debajo del más alto de la
                anterior y los dos inputs de una fila quedan a la misma altura aunque uno
                tenga indicación abajo (xcons-docs#609). */}
            <Col xs={24} md={12}>
              <Form.Item
                style={{ marginBottom: 7 }}
                label={t("products.import.form.label.headerLine")}
                name="firstLine"
                rules={[{ required: true }]}
                extra={t("products.import.form.small.headerLine")}
              >
                <Input
                  type="number"
                  placeholder={t("products.import.form.placeholder.headerLine")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label={"SKU"} name="sku" rules={[{ required: true }]}>
                <Input
                  placeholder={t("products.import.form.placeholder.sku")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.name")}
                name="name"
              >
                <Input
                  placeholder={t("products.import.form.placeholder.name")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.brand")}
                name="brand"
              >
                <Input
                  placeholder={t("products.import.form.placeholder.brand")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.price")}
                name="price"
                rules={[{ required: true }]}
                extra={t("products.import.form.small.price")}
              >
                <Input
                  placeholder={t("products.import.form.placeholder.price")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.costPrice")}
                name="costPrice"
                extra={t("products.import.form.small.costPrice")}
              >
                <Input
                  placeholder={t("products.import.form.placeholder.costPrice")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.taxes")}
                name="taxes"
              >
                <Select>
                  <Select.Option value={false}>Not included</Select.Option>
                  <Select.Option value={true}>Included</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.specialPrice")}
                name="specialPrice"
                extra={t("products.import.form.small.specialPrice")}
              >
                <Input
                  placeholder={t(
                    "products.import.form.placeholder.specialPrice",
                  )}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.specialPriceFrom")}
                name="specialPriceFrom"
                extra={t("products.import.form.small.specialPriceFrom")}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.specialPriceTo")}
                name="specialPriceTo"
                extra={t("products.import.form.small.specialPriceTo")}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.dateFormat")}
                name="dateFormat"
                extra={t("products.import.form.small.dateFormat")}
              >
                <Select>
                  <Select.Option value="dd/mm/yyyy">dd/mm/yyyy</Select.Option>
                  <Select.Option value="mm/dd/yyyy">mm/dd/yyyy</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.stock")}
                name="stock"
                extra={
                  <span style={{ whiteSpace: "pre-line" }}>
                    {t("products.import.form.small.stock")}
                  </span>
                }
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.leadtime")}
                name="leadTime"
                extra={
                  <span style={{ whiteSpace: "pre-line" }}>
                    {t("products.import.form.small.leadtime")}
                  </span>
                }
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.featured")}
                name="featured"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.manufacturerSKU")}
                name="manufacturerSku"
                extra={t("products.import.form.small.manufacturerSKU")}
              >
                <Input
                  placeholder={t(
                    "products.import.form.placeholder.manufacturerSKU",
                  )}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("products.import.form.label.enabled")}
                name="enabled"
                extra={
                  <span style={{ whiteSpace: "pre-line" }}>
                    {t("products.import.form.small.enabled")}
                  </span>
                }
              >
                <Input
                  placeholder={t("products.import.form.placeholder.enabled")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={24} lg={24}>
              <Form.Item
                label={t("products.import.form.label.customColumns")}
                name="customColumns"
                extra={t("products.import.form.small.customColumns")}
              >
                <Select
                  mode="tags"
                  tokenSeparators={[","]}
                  allowClear
                  placeholder={t(
                    "products.import.form.placeholder.customColumns",
                  )}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Form>
    );
  },
);
